import './my-referrals-list.scss';

import CircularLoading from '../../../../Common/CircularLoading/CircularLoading';

function MyReferralsList({ referrals = [], isLoading }) {
  return (
    <div className="my-referrals-section">
      <h3 className="my-referrals-title">My Referrals</h3>
      <div className="my-referrals-list">
        {isLoading ? (
          <div className="loading-container">
            <CircularLoading className="loading-gif-waiting" />
          </div>
        ) : referrals.length === 0 ? (
          <div className="no-referrals">
            <p>You haven't referred anyone yet.</p>
          </div>
        ) : (
          referrals.map((referral) => (
            <div key={referral.id} className="referral-item">
              <div className="referral-info">
                <span className="referral-icon">👤</span>
                <span className="referral-name">{referral.emailTo}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default MyReferralsList;
